import React, { Component } from "react";
import { NavLink, Link } from "react-router-dom";
import styled from "styled-components";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { auth } from "../../config";
import logo from "../../assets/logo.png";

const Nav = styled.nav`
  background: #fff;
  height: 62px;
  position: sticky;
  top: 0;
  z-index: 9999;
  box-shadow: 6px 6px 25px rgba(0, 0, 0, 0.15) .navbar-brand span {
    background: #fff;
  }
`;
const NavItem = styled.div`
  a {
    font-size: 0.9rem;
    font-weight: 500;
    text-transform: uppercase;
  }
  &:hover {
    background: #f4f4f4;
  }
`;

class Topnav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isActive: false,
      location: (this.props.location && this.props.location.pathname) || ""
    };
    this.toggleBurger = this.toggleBurger.bind(this);
  }

  toggleBurger() {
    this.setState({
      isActive: !this.state.isActive
    });
  }

  componentWillReceiveProps(nextProps) {
    const location = nextProps.location && nextProps.location.pathname;
    if (location) this.setState({ location });
  }

  render() {
    const { isActive } = this.state;
    const active = isActive ? "is-active" : "";
    const burgerClass = "navbar-burger " + active;
    const menuClass = "navbar-menu " + active;
    const user = this.props.user;

    return (
      <Nav className="navbar ph6-l bb b--near-white">
        <div className="navbar-brand">
          <Link to="/" className="navbar-item">
            <img className="va" src={logo} alt="logo" />
            <span className="f5 fw5 pl2 dark-blue">DSA RECRUITMENT PORTAL</span>
          </Link>
          <div onClick={this.toggleBurger} className={burgerClass}>
            <span />
            <span />
            <span />
          </div>
        </div>

        <div className={menuClass}>
          <div className="navbar-start">
            <NavItem className="navbar-item">
              <NavLink to="/">Home</NavLink>
            </NavItem>

            <NavItem className="navbar-item ">
              <NavLink to="/office">Office Home </NavLink>
            </NavItem>

            <NavItem className="navbar-item ">
              <NavLink to="/faq">FAQ</NavLink>
            </NavItem>

            <NavItem className="navbar-item ">
              <NavLink to="/vacancies">Vacancies</NavLink>
            </NavItem>
          </div>
          <div className="navbar-end">
            <div className="navbar-item">
              <Link to="/office/create" className="button is-link">
                Post new job
              </Link>
            </div>

            <div className="navbar-item">
              <Link to="/register" className="button is-link">
                Create admin user
              </Link>
            </div>

            <NavItem className="navbar-item">
              {!user ? (
                <NavLink to="/login">Login</NavLink>
              ) : (
                <a onClick={() => auth.signOut()}>Logout</a>
              )}
            </NavItem>
          </div>
        </div>
      </Nav>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    user: state.user
  };
};

export default connect(mapStateToProps)(withRouter(Topnav));



// WEBPACK FOOTER //
// ./src/components/common/TopnavAdmin.js